// extracted by mini-css-extract-plugin
module.exports = {"header":"_2Y_vL","wrapper":"_3JoPB","headerWrapper":"_2S_X0","headerLink":"_1JmVu","channelsWrapper":"n75Si","channelSectionTitle":"JvJB-","channelSectionSubtitle":"_1eJEq"};